<template>
    <div class="auth">            
        <a-spin :spinning="isLoading" size="large">
            <div class="spin-content">
                <height-watcher>
                    <a-row v-if="noLiveSessions == false" type="flex" justify="space-around" align="middle" slot-scope="{ height, offset }"
                            :offset="offset"
                            :style="{
                                'max-height': height - (80 + 80) + 'px',
                                height: height - (80 + 80) + 'px',
                            }">
                            <a-col :span="24" :md="12" :lg="{span: 12, offset: 0}" :xl="{span: 12, offset: 2}" class="col-form">
                                <div style="display:flex;align-items:center;justify-content:center">
                                    <img src="/images/logos/logo.svg" alt="" style="height:100px;width:100px" />
                                    <h2 class="ml-40 mb-15">{{ $t('page-titles.live-communications') }}</h2>

                                </div>
                                    <h5 class="font-regular text-muted">{{ $t('live-communications.sub-title')}}</h5>

                                <a-form
                                    id="components-form-demo-normal-login"
                                    class="login-form"
                                    @submit="handleSubmit"
                                    :hideRequiredMark="true">
                                    
                                    
                                        <!-- :label="$t('live-communications.auth.name')"  -->
                                    <a-form-item 
                                        class="mb-10" 
                                        :colon="false"
                                        :validate-status="validations.statusName"
                                        :help="validations.helpName">
                                        <!-- <label class="pl-10">{{$t('signin.user-name-input-label')}}</label> -->
                                        <label 
                                            style="color: #000;font-size:15px;font-weight: 600" 
                                            class="ml-10"
                                        >
                                            {{$t('live-communications.auth.name')}} 
                                            <b style="color:red"> (*)</b>
                                        </label>
                                        <a-input
                                            class="form-input"
                                            :placeholder="$t('live-communications.auth.name')"
                                            v-model="name"
                                        />
                                        
                                    </a-form-item>

                                        <!-- :label="$t('live-communications.auth.mobile')"  -->
                                    <a-form-item 
                                        class="mb-10" 
                                        :colon="false"
                                        :validate-status="validations.statusMobile"
                                        :help="validations.helpMobile">
                                        <!-- <label class="pl-10">{{$t('signin.user-name-input-label')}}</label> -->
                                        <label 
                                            style="color: #000;font-size:15px;font-weight: 600" 
                                            class="ml-10"
                                        >
                                            {{$t('live-communications.auth.mobile')}} 
                                            <b style="color:red"> (*)</b>
                                        </label>
                                        <a-input
                                            class="form-input"
                                            :placeholder="$t('live-communications.auth.mobile')"
                                            v-model="mobile"
                                        />
                                        
                                    </a-form-item>

                                        <!-- :label="$t('live-communications.auth.address')"  -->
                                    <a-form-item 
                                        class="mb-10" 
                                        :colon="false"
                                        
                                        :validate-status="validations.statusAddress"
                                        :help="validations.helpAddress">
                                        <!-- <label class="pl-10">{{$t('signin.user-name-input-label')}}</label> -->
                                        <label 
                                            style="color: #000;font-size:15px;font-weight: 600" 
                                            class="ml-10"
                                        >
                                            {{$t('live-communications.auth.address')}} 
                                            <!-- <b style="color:red"> (*)</b> -->
                                        </label>
                                        <a-select
                                            class="form-input"
                                            :placeholder="$t('form-placeholder.district')"
                                            show-search
                                            @search="filterDistrict"
                                            @change="onChangeDistrictSelection"
                                            :value="address"
                                        >
                                            <a-select-option v-show="isLocal == 'bn'" v-for="item in districts" :key="item.nameBn" :value="item.nameBn">
                                                {{ item.nameBn }}
                                            </a-select-option>
                                            <a-select-option v-show="isLocal == 'en'" v-for="item in districts" :key="item.nameEn" :value="item.nameEn">
                                                {{ item.nameEn }}
                                            </a-select-option>
                                        </a-select>
                                        
                                    </a-form-item>

                                        <!-- :label="$t('live-communications.auth.purpose')"  -->
                                    <a-form-item 
                                        class="mb-10" 
                                        :colon="false"
                                        :validate-status="validations.statusPurpose"
                                        :help="validations.helpPurpose"
                                    >
                                        <label 
                                            style="color: #000;font-size:15px;font-weight: 600" 
                                            class="ml-10"
                                        >
                                            {{$t('live-communications.auth.purpose')}} 
                                            <!-- <b style="color:red"> (*)</b> -->
                                        </label>
                                        <!-- <a-select
                                            class="form-input"
                                            :placeholder="$t('live-communications.auth.purpose')"
                                            @change="onChangePurposeSelection"
                                            :value="purpose"
                                        >
                                            <a-select-option v-for="item in $t('dropdown-items.reasons')" :key="item" :value="item">
                                                {{ item }}
                                            </a-select-option>
                                        </a-select> -->
                                            <!-- <strong style="color: #000; font-weight:600"> {{$t('form-label.reason-for-meeting')}}  </strong>  -->
                                            <a-radio-group class="ml-20" v-model="purpose" size="small" >
                                                <a-radio value="Personal">{{$t('radio-btn-caption.personal')}} </a-radio>
                                                <a-radio value="Official">{{$t('radio-btn-caption.official')}} </a-radio>
                                            </a-radio-group>
                                    </a-form-item>

                <!-- :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"  -->
                <!-- class="ml-10"  -->
                <!-- @search="filterOfficials" -->
                <!-- show-search -->
                                    <a-form-item
                                        v-show="allOfficials.length > 1"
                                        :label="$t('apply.step-2.appointment-official-label')"
                                        :validate-status="validations.statusSelectedOfficial"
                                        :help="validations.helpSelectedOfficial">
                                        <a-select
                                            :disabled="isLoading"
                                            :loading="isLoading"
                                            :value="selectedOfficial"
                                            :filter-option="false"
                                            :not-found-content="isLoading ? undefined : null"
                                            class="form-input"
                                            :placeholder="$t('apply.step-2.appointment-official-placeholder')"
                                            @change="onChangeOfficialSelection">
                                            <a-spin v-if="isLoading" slot="notFoundContent" size="large" />
                                            <a-select-option v-for="item in officials" :key="item.id" :value="item.id">
                                                <span role="img" style="margin-right: 20px;">
                                                    <a-avatar shape="square" :src="item.imageUrl" />
                                                </span>
                                                {{ item.name }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>


                                    <a-form-item class="">
                                        <a-button type="primary" block html-type="submit" class="login-form-button">
                                            {{$t('live-communications.auth.join')}}
                                        </a-button>
                                    </a-form-item>



                                </a-form>

                                <!-- <b>{{$t('signin.note-p1')}} <a href="/appointments/apply" @click.prevent="navigateTo('Apply')">{{$t('signin.note-p2')}}</a> {{$t('signin.note-p3')}}</b><br />
                                <b>{{$t('signin.note-p4')}} <a href="/forgot-password" @click.prevent="navigateTo('ForgotPassword')">{{$t('signin.note-p5')}}</a></b> -->
                            </a-col>
                        
                            <!-- <a-col :span="24" :md="12" :lg="12" :xl="12" class="col-img">
                                <img src="/images/logos/logo.svg" alt="" style="height:200px;width:200px" />
                            </a-col> -->

                    </a-row> 
                </height-watcher>
                <!-- <height-watcher> -->
                    <div v-if="noLiveSessions == true" style="display: flex; flex-direction: column; height: 300px; justify-content: center; align-items: center;">
                        <h3>{{ $t('live-communications.no-live-session') }}</h3>
                        <a-button style="margin-top: 15px" type="primary" size="large" @click="navigateTo('Index')">{{$t('apply.done-step.btn-caption')}}</a-button>
                    </div>
                <!-- </height-watcher> -->
            </div>
        </a-spin>
    </div>
</template>

<script>
import { host, officialsClient, liveCommunicationsClient } from '../../api/config';
import HeightWatcher from "../../components/height-watcher/HeightWatcher.vue";
import { navigationMixin } from "../../mixins/navigation-mixin"; 
import{ BanglaUtils } from "../../helpers/bangla-utils.js";
import districts from "../../data/districts.json";
import { mapState } from 'pinia';
import { useLocaleStore } from "../../stores/locale-store.js";


export default {
    components: {
        HeightWatcher
    },
    mixins: [ navigationMixin ],
    data() {
        return {
            districts: districts,
            name: '',
            mobile: '',
            address: '',
            purpose: 'Personal',
            selectedOfficial: '',
            selectedOfficialAppName: '',
            officials: [],
            allOfficials: [],
            isLoading: true,
            noLiveSessions: false,
            validations: {
                statusName: "",
                helpName: "",
                statusMobile: "",
                helpMobile: "",
                statusAddress: "",
                helpAddress: "",
                statusPurpose: "",
                helpPurpose: ""
            },
        }
    },
    computed:{
        ...mapState(useLocaleStore, ['locale']),
        isLocal(){
            if (this.locale == "bn"){
                return "bn";
            }
            return "en";
        }
    },
    methods: {
        filterDistrict(e){
            let allDistrict = this.$t('dropdown-items.districts');
            // this.address = allDistrict.filter(o => o.toLowerCase().includes(e.toLowerCase()));
            let addressArray = districts.filter(o => o.nameEn.toLowerCase().includes(e.toLowerCase()) || o.nameBn.toLowerCase().includes(e.toLowerCase()));
            // this.address = districts.filter(o => o.nameEn.toLowerCase().includes(e.toLowerCase()) || o.nameBn.toLowerCase().includes(e.toLowerCase()));
            // this.address = addressArray.map(dist => {

            //     if(this.isLocal == 'bn'){
            //         console.log(this.isLocal);

            //         return dist.nameBn;
            //     }else {
            //         console.log(this.isLocal);

            //         return dist.nameEn;
            //     }
            // });
            // console.log(this.address);
            return this.address = addressArray.map(dist => {

                if(this.isLocal == 'bn'){
                    console.log(this.isLocal);

                    return dist.nameBn;
                }else {
                    console.log(this.isLocal);

                    return dist.nameEn;
                }
            });
            // console.log(findDistrict);
        },
        onChangeDistrictSelection(e){
            this.address = e;
            // console.log(this.address);
        },
        onChangePurposeSelection(e){
            if ( e == "ব্যক্তিগত"){
                this.purpose = "Personal";
            }
            if ( e == "দাপ্তরিক"){
                this.purpose = "Official";
            }
            // this.purpose = e;
            // console.log(this.purpose);
        },
        clearValidations() {
            Object.keys(this.validations).forEach(key => {
                this.validations[key] = '';
            });
        },
        validate() {
        
            this.clearValidations();
                
            
            if (this.name.trim().length == 0) {
                this.validations.statusName = 'error';
                this.validations.helpName = this.$t('error-message.name');
                return false;
            }

            if (this.mobile.trim().length == 0) {
                this.validations.statusMobile = 'error';
                this.validations.helpMobile = this.$t('error-message.mobile');
                return false;
            }
            let mobileEn = BanglaUtils.banglaToEnglishNumber(this.mobile);
            if (!mobileEn.match(/(^(\+8801|8801|01|008801))[1|3-9]{1}(\d){8}$/)) {
                this.validations.statusMobile = 'error';
                this.validations.helpMobile = this.$t('error-message.mobile');
                return false;
            }

            // if (this.address.trim().length == 0) {
            //     this.validations.statusAddress = 'error';
            //     this.validations.helpAddress = this.$t('error-message.district');
            //     return false;
            // }

            // if (this.purpose.trim().length == 0) {
            //     this.validations.statusPurpose = 'error';
            //     this.validations.helpPurpose = this.$t('error-message.purpose');
            //     return false;
            // }

            return true;

        },
        
        
        handleSubmit(e) {
            e.preventDefault();

            if (this.validate()){
                localStorage.setItem('anonymous-name', this.name);
                localStorage.setItem('anonymous-mobile', this.mobile);
                localStorage.setItem('anonymous-address', this.address);
                localStorage.setItem('anonymous-purpose', this.purpose);
                let mobileEn = BanglaUtils.banglaToEnglishNumber(this.mobile);
                this.mobile = mobileEn.replace(/^((\s|\-)|(\+88|\88){1})/g, '');
                this.$emit('success', { name: this.name, mobile: this.mobile, address: this.address, purpose: this.purpose, officialId: this.selectedOfficial, appName: this.selectedOfficialAppName });
                // this.isLoading = true;

                // let submitData = {
                //     userName : this.userName,
                //     password : this.password
                // }
                
                // // console.log(submitData);
                // this.signIn(submitData).then(() => {
                //     if (this.currentUser) {
                //         this.isLoading = false;
                //         if (this.currentUser.roles.includes('USER'))
                //             this.navigateTo('VisitorDashboard');
                //         else {
                //             this.navigateToDashboard();
                //         }
                //     }
                // }).catch(error => {
                //     this.isLoading = false;
                //     if (error == 'auth_error') {
                //         this.validations.statusUserName = 'error';
                //         this.validations.helpUserName = this.$t('error-message.server-miss-match');
                //         this.validations.statusPassword = 'error';
                //         this.validations.helpPassword = this.$t('error-message.server-miss-match');
                //     } else if (error == 'network_error') {  
                //         this.errorToast('Network Error, Please Check Your Internet Connection');
                //     } else {
                //         this.errorToast('System is under maintenance');
                //     }
                // });

            }
        },
        populateAnonymousUserInfo() {
            let name = localStorage.getItem('anonymous-name');
            let mobile = localStorage.getItem('anonymous-mobile');
            let address = localStorage.getItem('anonymous-address');
            let purpose = localStorage.getItem('anonymous-purpose');

            if (name)
                this.name = name;
            
            if (mobile)
                this.mobile = mobile;
            
            if (address)
                this.address = address;
            
            if (purpose)
                this.purpose = purpose;

            console.log('name :: ' + this.name);
            console.log('mobile :: ' + this.mobile);
            console.log('address :: ' + this.address);
            console.log('purpose :: ' + this.purpose);

        },
        filterOfficials(input) {
            this.officials = this.allOfficials.filter(o => o.name.toLowerCase().includes(input.toLowerCase()));
        },
        onChangeOfficialSelection(e) {
            this.selectedOfficial = e;
        },
    },
    mounted() {
        this.populateAnonymousUserInfo();

        this.isLoading = true;

        liveCommunicationsClient.fetchAllOfPage().then(res => {
            if (!res.networkError && res.body && res.body) {
                if (!res.body || res.body.length == 0) {
                    this.isLoading = false;
                    this.noLiveSessions = true;
                    return;
                }
                this.selectedOfficialAppName = res.body[0].appName;
                res.body = res.body.map(e => e.official);
                res.body.forEach(o => {
                    if (!o.imageUrl || o.imageUrl.trim().length == 0)
                        o.imageUrl = '/images/default-avatar.jpg';
                    else
                        o.imageUrl = host + o.imageUrl;
                });
                this.allOfficials = res.body;
                this.officials = res.body;
                if (this.officials.length > 0)
                    this.selectedOfficial = this.officials[0].id;
            } else {
                /* TODO: show error */
            }
            this.isLoading = false;
        });
    }
}
</script>